import { render, staticRenderFns } from "./CloseIncidenceModal.vue?vue&type=template&id=088d3b91&"
import script from "./CloseIncidenceModal.vue?vue&type=script&lang=js&"
export * from "./CloseIncidenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports